import { Typography } from "@mui/material";
import { theme } from "../../Common/UI/styles/theme";
import helpPageEventPicture1 from "../../img/HelpPageEventPicture1.png";
import helpPageEventPicture2 from "../../img/HelpPageEventPicture2.png";
import helpPageEventPicture3 from "../../img/HelpPageEventPicture3.png";
import helpPageEventPicture4 from "../../img/HelpPageEventPicture4.png";
import helpPageEventPicture5 from "../../img/HelpPageEventPicture5.png";
import helpPageEventPicture6 from "../../img/HelpPageEventPicture6.png";
import helpPageEventPicture7 from "../../img/HelpPageEventPicture7.png";
import helpPageEventPicture8 from "../../img/HelpPageEventPicture8.png";
import helpPageEventPicture9 from "../../img/HelpPageEventPicture9.png";
import helpPageEventPicture10 from "../../img/HelpPageEventPicture10.png";
import helpPageEventPicture11 from "../../img/HelpPageEventPicture11.png";
import helpPageEventPicture12 from "../../img/HelpPageEventPicture12.png";
import helpPageEventPicture13 from "../../img/HelpPageEventPicture13.png";
import EventActions from "../../img/EventActions.png";
import ReportsTab1 from "../../img/ReportsTab1.png";

export default function EventsHelp() {
  return (
    <>
      <Typography variant="h6" className="release-title" color={theme.palette.error.main}>
        Spirit Night App SOP
      </Typography>
      <ul>
        <li>
          <b>Creating an Event</b>
          <ul>
            <li>
              Click the <span style={{ fontWeight: "bold", backgroundColor: "#ffcccc", padding: "2px 5px", borderRadius: "4px" }}>+ CREATE</span> button in the top right corner of the events list screen.
              <br />
              <img src={helpPageEventPicture1} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
            </li>
            <li><strong>Select your Location</strong> from the <strong>dropdown menu</strong>.</li>
            <li>
              Once location is selected make sure the store’s <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Managing Partners and Requesters Name and Email</span> is correct as this will
              automatically be filled when you pick your location.
            </li>
            <li>
              Choose your <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Event Date</span> by using the calendar button.
            </li>
            <li>
              Click the red <span style={{ fontWeight: "bold", backgroundColor: "#ffcccc", padding: "2px 5px", borderRadius: "4px" }}>SELECT</span> button to choose your vendor.
              <br />
              <img src={helpPageEventPicture2} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
            </li>
            <li>
              <span style={{ fontWeight: "bold", borderRadius: "4px" }}> "Select Vendor"</span> window will appear. Type in the organization’s name, click{" "}
              <span style={{ fontWeight: "bold", backgroundColor: "#ffcccc", padding: "2px 5px", borderRadius: "4px" }}>SEARCH</span>{" "}
              <span style={{ fontWeight: "bold", borderRadius: "4px" }}>(Note: This may take a few minutes to load)</span> and <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Review</span>{" "}
              the vendor details:
              <ul>
                <li>
                  Ensure the <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Name, Legal Address, Payment Address</span> and{" "}
                  <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Tax ID</span> match the information provided on the partner’s tax identification document.
                </li>
                <li>Do not select a vendor if the information does not match exactly.</li>
                <li>
                  <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Check the box</span> next to the correct vendor and click{" "}
                  <span style={{ fontWeight: "bold", backgroundColor: "#ffcccc", padding: "2px 5px", borderRadius: "4px" }}>SELECT</span> at the bottom left corner.
                  <br />
                  <img src={helpPageEventPicture3} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <b>Vendor Setup</b>
          <ul>
            <li>
              If you cannot find the desired vendor or your information does not match exactly, click{" "}
              <b style={{ backgroundColor: "#ffcccc", padding: "2px 4px", textDecoration: "underline" }}>HERE</b> button to fill out the Vendor Setup Steps: <br />
              <img src={helpPageEventPicture4} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <b>Verifying Vendor Information</b>
          <ul>
            <li>
              After selecting a vendor, confirm the <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Vendor Legal</span> and <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Payment Addresses</span>{" "}
              match the partner's tax document by clicking the review boxes below.
            </li>
            <li>Once all details are verified, submit your event by clicking red CREATE at the top right corner.</li>
            <li>
              You will receive an automated email within <span style={{ fontWeight: "bold", borderRadius: "4px" }}> 7 days</span> confirming the{" "}
              <span style={{ fontWeight: "bold", borderRadius: "4px" }}> status</span> of your event.
              <img src={helpPageEventPicture5} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <b>Approval Process</b>
          <ul>
            <li>
              If <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Approved</span>: No further action is needed until the event is held.
            </li>
            <li>
              <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Declined</span>: You will receive an automated email with the required actions to address issue(s). You will need to click the
              link in the email that will navigate you back to your Event.
              <ul>
                <li>
                  You will need to follow the steps as outlined in the Event Comments.
                  <br />
                  <img src={helpPageEventPicture6} alt="Event Report" style={{ maxWidth: "100%", height: "auto", margin: "8px 0" }} />
                  <img src={helpPageEventPicture7} alt="Event Report" style={{ maxWidth: "100%", height: "auto", margin: "8px" }} />
                </li>
              </ul>
            </li>
            <li>
              <span>Events can be approved or denied only by <strong>Admin</strong> or <strong>Field Marketer</strong> roles. Additionally, Admins can also manually <strong>mark an event as archived</strong>, as long as it has not yet progressed past "Accounting Approval" step: <br /></span>
              <img src={EventActions} alt="Event Actions" style={{ maxWidth: "100%", height: "auto", margin: "8px" }} />
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <b>Sales and Donation Contribution</b>
          <ul>
            <li>
              Requester will receive an automated email the day after the event.
            </li>
            <li>
              Click the <span style={{ fontWeight: "bold", borderRadius: "4px" }}> LINK</span> in the email and follow the required steps. Add any additional sales/donations for this event. If
              there are no additional sales/donations <span style={{ fontWeight: "bold", borderRadius: "4px" }}> YOU MUST</span> enter{" "}
              <span style={{ fontWeight: "bold", borderRadius: "4px" }}> $0</span> in these fields.

              <img src={helpPageEventPicture8} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
              <img src={helpPageEventPicture9} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px" }} />
            </li>
            <li>
              After inputting <span style={{ fontWeight: "bold", borderRadius: "4px" }}> Additional Sales Contribution and Additional Donation Contribution</span>, scroll to the top and click the red{" "}
              <span style={{ fontWeight: "bold", backgroundColor: "#ffcccc", padding: "2px 5px", borderRadius: "4px" }}>COMPLETE</span> button on the top left corner.<br /> Note: if your event was a
              no-show, rescheduled, or canceled, click the red <span style={{ fontWeight: "bold", backgroundColor: "#ffcccc", padding: "2px 5px", borderRadius: "4px" }}>CANCEL</span> button.
              <br />
              <img src={helpPageEventPicture10} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <b>Accounting Approval, Invoiced, and Paid</b>
          <ul>
            <li>
              <b>Accounting Approval:</b>
              <ul>
                <li>Your Event's Sales/Donations will be imported from DOMO.</li>
                <li>Your total Sales/Donation will be reviewed and approved by the AP team.</li>
              </ul>
            </li>
            <li>
              <b>Invoiced:</b>
              <ul>
                <li>Once your Event has received Accounting Approval, an invoice will be generated.</li>
              </ul>
            </li>
            <li>
              <b>Paid:</b>
              <ul>
                <li>Your event is now ready to be Paid! Once paid, you will receive an automated email.</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <b>Audit trail for events</b>
          <p>The Audit tab on the event page can be used to see its full history of changes - the date on which the action occurred and what is the old and new values. The table displayed is paginated and allows for sorting by clicking on any of the column names:</p>
          <img src={helpPageEventPicture11} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px" }} />
        </li>
      </ul>
      <ul>
        <li>
          <b>Reports Tab</b>
          <ul>
            <li>
              <span>Here, permitted users can extract reporting data for specific dates, control shown columns and export the result as CSV. Additionally, rows can be filtered by a set
              <strong> Store location</strong> value. An additional row with total calculations exists at the end of the listed check numbers for each store location which has a distinct color and text weight:</span>
              <img src={ReportsTab1} alt="Reports Tab" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <b>Additional Information</b>
          <ul>
            <li>
              Everything you need to have a successful event is in this SOP. However, if you require any additional assistance CLICK{" "}
              <img src={helpPageEventPicture12} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
              <br />
              <img src={helpPageEventPicture13} alt="Event Report" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
}
